import { Module } from "vuex";
import { RootState } from "@/store/interfaces/root";

import { state } from "./state";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { actions } from "./actions";

export const root: Module<RootState, RootState> = {
  state,
  getters,
  mutations,
  actions
};
